const { transliterate } = require('transliteration');
const { customAlphabet } = require('nanoid');
const nanoid = customAlphabet('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz', 10);

// Those objects class are used as responsed from the BIMSearch engine
export class DataForMenus {
    constructor() {
        this.quickCounterData = null; // [] of QuickDataField, elements order: count, length, area, volume

        // menu lists
        this.templates = null; // [] of strings
        this.templatesCount = null; //[] of numbers number of elements for each template
        this.templatesFolder = null; // Dictionary<string, [] of string>
        this.categories = null; // [] of strings
        this.filterByOptions = null; // [] of strings
        this.filterValues = null; // [] of string or numbers
        this.properties = null; // [] of strings
        this.groupingOptions = null; // [] of strings
        this.commonCategories = null; // [] of strings
        this.uncommonCategories = null; // [] of strings
        this.commonProperties = null; // [] of strings
        this.uncommonProperties = null; // [] of strings
        this.commonGroupingOptions = null; // [] of strings
        this.uncommonGroupingOptions = null; // [] of strings
        this.colorScheme = null; // object of type ColorConditions 
        this.customColumns = null; // object of type CustomColumns 
        this.settings = null; // object of type TemplateSettings
        this.customProperties = null; // [] of strings
        this.proProperties = null; // [] of strings

        // MenusSelection 
        this.selection = null;
    }

    empty() {
        this.templates = []; // [] of strings
        this.templatesCount = []; //[] of numbers number of elements for each template
        this.templatesFolder = {}; // Dictionary<string, [] of string>
        this.categories = []; // [] of strings
        this.filterByOptions = []; // [] of strings
        this.filterValues = []; // [] of string or numbers
        this.properties = []; // [] of strings
        this.groupingOptions = []; // [] of strings
        this.commonCategories = []; // [] of strings
        this.uncommonCategories = []; // [] of strings
        this.commonProperties = []; // [] of strings
        this.uncommonProperties = []; // [] of strings
        this.commonGroupingOptions = []; // [] of strings
        this.uncommonGroupingOptions = []; // [] of strings
        this.conditionalFormatting = null; // object of type ColorConditions 
        this.customColumns = null; // object of type CustomColumns 
        this.customProperties = null; // [] of strings
        this.proProperties = null; // [] of strings
    }
}

export class QuickDataField {
    constructor(name, value = 0, unit = null) {
        this.name = name;
        this.value = value;
        this.unit = unit;
    }
}

export class MenusSelection {
    constructor(
        selectedCategories,
        selectedSecondFilter,
        selectedFilterValues,
        selectedProperties,
        selectedGroups,
        searchValue
    ) {
        this.categories = selectedCategories; // string
        this.secondFilter = selectedSecondFilter; // string
        this.filterValues = selectedFilterValues; // [] of strings
        this.properties = selectedProperties; // [] of strings
        this.groups = selectedGroups; // [] of strings
        this.searchValue = searchValue
    }
}

// n - number of colums in the table, not including check box
// m - number of lines in the table, not including header and total line
export class DataForTable {
    constructor() {
        this.rowsData = []; // size m[] of RowInfo
        this.columnsInfo = [];  // size n[] of ColumnInfo
    }
}

export class ColumnInfo {
    constructor(headerKey, header, type, unit, summable = false) {
        this.headerKey = headerKey; // header key - property name
        this.header = header; // column name
        this.type = type; // column type
        this.unit = unit; // column unit
        this.options = {};
        this.options["summable"] = summable;
        this.formulaKey = transliterate(headerKey).replace(/[^a-zA-Z0-9]/g, '');
    }
}

export class RowInfo {
    constructor(lineElements) {
        this.lineElements = lineElements; // array of row elements IDs in view
        // will include fields for each headerKey in ColumnsInfo
    }
}

export class QuickInfo {
    constructor(creationTime, quickData, parameters, description) {
        this.creationTime = creationTime; // Timestamp // negative value --> don't display
        this.quickData = quickData; // [] of QuickDataField
        this.parameters = parameters; // [] of string
        this.descreption = description; // string
    }
}

export class PropertyInfo {
    constructor() {
        this.type = valueTypes.unknown; //valueTypes
        this.values = []; // [] of possible values
    }
}

export class DateRange {
    constructor(startDate, endDate) {
        this.min = startDate; // Date object
        this.max = endDate; // Date object
    }
 }

// Exported enum
export const operatorValues = {
    equal: 0,
    notEqual: 1,
    greater: 2,
    less: 3,
    greaterOrEqual: 4,
    lessOrEqual: 5,
};

// Exported enum
export const valueTypes = {
    unknown: -1,
    number: 0,
    text: 1,
    date: 2,
    customNumber: 10,
    customText: 11,
    customDate: 12,
    customBool: 13,
    customLink: 14,
    customEnumSingle: 15,
    customEnumMulty: 16,
    proNumber: 20,
    proText: 21,
    proDate: 22,
    proBool: 23,
    proLink: 24,
    proEnumSingle: 25,
    proEnumMulty: 26,
};

// class that represent the customParameter
export class CustomParameter {
    constructor(name, type, values = null) {
        this.name = name; // string
        this.type = type; // valueTypes enum
        this.values = values; // array of possible values for enum paramter, will be null for any other type
    }

    // Copy constructor
    static Copy(originalCustomParameter) {
        var newValues = originalCustomParameter.values == null ? null : [...originalCustomParameter.values];
        return new CustomParameter(originalCustomParameter.name, originalCustomParameter.type, newValues);
    }
}

// class containing the full data needed for the execution report excels
export class ExecutionReport {
    constructor() {
        this.id = null; // id is modelUrl
        this.modelUrl = null; // modelUrl
        this.reportSelections = null; // Dictionary<string, list<Collection>> folder name (item number) => list of selection sets for each month
        this.creationDate = null; // the date the report was created
        this.budgetItemsData = null; // Dictionary<string, budgetItemData> item number => budgetItemData
        this.projectName = null; // string - ACC project name
    }
}

export class BudgetItemData {
    constructor() {
        this.itemNumber = null; // string - QBS_Item_number 
        this.description = null; // string - QBS_Item_description
        this.unit = null; // string - QBS_Item_Unit (multiple choice: Unit, Length, Area, Volume)
        this.unitMeasurement = null; // string - the unit measurement according to the unit (e.g., if unit is Length, the measurement can be "m", "ft", etc.)
        this.totalAssigned = null; // double - total assigned for this item number based on unit
    }
}

export const PRO_PARAM_NAMES = {
    itemNum: "<$>QBS_Item_number",
    desc: "<$>QBS_Item_description",
    itemUnit: "<$>QBS_Item_Unit",
    constructionDate: "<$>Construction date",
    calculationGroup: "<$>Calculation_Group"
}
        
export const QBS_Item_Unit_Values = {
    Unit: "Unit",
    Length: "Length",
    Area: "Area",
    Volume: "Volume"
}